import React from 'react';
import { franchiseList, statusList } from '../../../helpers/uiFunctions/uiHelpers';

class ClientFilters extends React.Component {
    render() {
        const count = this.props.count;
        const setFilter = this.props.setFilter;
        const filter = this.props.filter;
        
        return(
            <React.Fragment>
                <div className="list-label">Filters</div>
                <div className="filters">
                    <div className="list-tabs">
                        <div className="tab active" onClick={() => setFilter("all", 1)}>All Clients</div>
                        <br/>
                        <em>Status: </em>
                        {statusList.map((status, index) =>
                            <div key={index} className={"tab status-"+status.value} onClick={() => setFilter(status.value, 2+index)}>{status.name}</div>
                        )}
                        <br/>
                        <em>Velocity: </em>
                        <div className="tab" onClick={() => setFilter("velocity", 5)}>Velocity</div>
                        <div className="tab" onClick={() => setFilter("lite", 6)}>Velocity Lite</div>
                        <div className="tab" onClick={() => setFilter("other", 7)}>Non-Velocity</div>
                        <br/>
                        <em>Program: </em>
                        <div className="tab" onClick={() => setFilter("ela", 8)}>All ELA</div>
                        <div className="tab" onClick={() => setFilter("omnify", 9)}>All Omnify</div>
                        <br/>
                        <em>Franchises: </em>
                        {franchiseList.map((franchise, index) =>
                            <div key={index} className={"tab franchise-"+franchise.name} onClick={() => setFilter(franchise.value, 10+index)}>{franchise.name}</div>
                        )}
                    </div>
                </div>
                <div className="list-label">{filter} Clients: {count ? (count) : ("Loading...")}</div>
            </React.Fragment>
        )
    }
}
export default ClientFilters;


// WEBPACK FOOTER //
// ./src/component_client/components/ClientExplorer/ClientFilters.js